import React from 'react';
import { useTranslation } from 'react-i18next';
import Base from '../Base';
import Title from '../../components/common/Title';
import WhoIsHere from '../../components/common/WhoIsHere';

/* The "Who is here" screen. Linked from the home only where the event switched it on; the API
   answers empty everywhere else, so an old link lands on an empty page, not on the numbers. */
const Page = () => {
  const { t } = useTranslation('common');
  return (
    <Base activeNav="home">
      <Title>{t('whoIsHere')}</Title>
      <WhoIsHere />
    </Base>
  );
};

export default Page;
